import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Accordion, AccordionActions, AccordionDetails, Button, Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import './styles.scss';
import { MdCached, MdAddCircleOutline, MdClose } from 'react-icons/md';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import MaterialTable from '@material-table/core';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { NotificationManager } from 'react-notifications';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function ShowComponent(props) {
    const [userItem, setUserItem] = useState([]);
    const [menuItem, setMenuItem] = useState();
    // eslint-disable-next-line
    const [expanded, setExpanded] = React.useState('panel1');
    const [valueKey, setKey] = useState([]);
    const [valueDescription, setDescription] = useState('');
    const [keys, setKeys] = useState();
    const [openM, setOpenM] = React.useState(false);
    const [idModal, setIdModal] = useState();
    const [users, setUsers] = useState();

    useEffect(() => {
        const DataMenu = {
            "ID" : 0
        }
        props.GetDataMenuAll();
        props.GetDataUser();
        props.GetDataPermission(DataMenu);
        props.GetDataUserMenu();
        // eslint-disable-next-line
    }, []
    );
    useEffect(() => {
        const DataMenu = {
            "ID" : 0
        }
        if (props.isResult) {
            props.GetDataMenuAll();
            props.GetDataUser();
            props.GetDataPermission(DataMenu);
            props.GetDataUserMenu();
        }
        // eslint-disable-next-line
    }, [props.isResult]);

    useEffect(() => {
        if (props.DataPermission !== undefined && props.DataPermission) {
            setKeys([{ id: -1, key: "Tất cả" }, ...props.DataPermission])
        };
    }, [props.DataPermission])
    useEffect(() => {
        if (props.DataUser) {
            setUsers([{ id: -1, email: "Tất cả" }, ...props.DataUser])
        };
    }, [props.DataUser])

    const handleClickOpen = (id) => {
        //console.log(id);
        setIdModal(id);
        setOpenM(true);
    };

    const handleClose = () => {
        setOpenM(false);
    };
    const DeleteButton = (id) => {
        //console.log(id);
        props.DeleteDataUserMenu(id);
        setOpenM(false)
    };
    // const EditButton = (DataUserMenu) => {
    //     //setReadOnly(true);
    //     const User = props.DataUser.find(item => item.userCode === DataUserMenu.userCode);
    //     if (User) {
    //         setUserItem([]);
    //         setUserItem(prev => [...prev, User]);
    //     }
    //     else {
    //         setUserItem([]);
    //     }
    //     const Permission = props.DataPermission.find(item => item.key === DataUserMenu.permission);
    //     if (Permission) {
    //         setKey([]);
    //         setKey(prev => [...prev, Permission]);
    //     }
    //     else {
    //         setKey([]);
    //     }
    //     console.log(Permission);
    //     setDescription(DataUserMenu.description);
    //     const MenuSelected = props.DataMenu.find(item => item.id === DataUserMenu.menuID);
    //     if (MenuSelected) {
    //         setMenuItem(MenuSelected);
    //     }
    // };

    //<IconButton className="editicon" onClick={() => EditButton(rowData)} ><EditIcon /></IconButton>
    const state = {
        columns: [
            { title: 'Email', width: 300, field: 'email', filtering: false, editable: 'never' },
            { title: 'Menu', width: 300, field: 'nameMenu', filtering: false, editable: 'never' },
            { title: 'Quyền', width: 300, field: 'permission', filtering: false, editable: 'never' },
            { title: 'Mô tả', width: 300, field: 'description', filtering: false, editable: 'never' },
            {
                title: 'Thao tác', width: 300, field: 'id', render: rowData => <div><IconButton className="deleteicon" onClick={()=>handleClickOpen(rowData.id)} ><DeleteOutlineIcon /></IconButton>
                    <Dialog
                        open={openM}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Xác nhận!"}
                            <IconButton style={{ marginLeft: 250 }} onClick={handleClose}><MdClose /></IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Bạn có thực sự chắc chắn muốn xóa quyền user này?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="PlanTemplate_0021 text-light" style={{ backgroundColor: '#DA9630' }} onClick={handleClose}  >
                                Hủy
                            </Button>
                            <Button className="PlanTemplate_0021 text-light" size='small' onClick={() => DeleteButton(idModal)} variant="contained" style={{ backgroundColor: 'var(--itsm-bg-btn)' }} autoFocus>
                                Xác nhận
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>, filtering: false, editable: 'never'
            },
        ]
    };
    const fn_SetMenuItem = (newValue) => {
        const DataMenu = {
            "ID" : newValue ? newValue.id : 0
        }
        props.GetDataPermission(DataMenu);
        setMenuItem(newValue);
    }
    const fn_SetUserItem = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.id === -1) || (!newValue.some(x => x.id === -1) && newValue.length === users.length - 1)) {
                setUserItem(users);
            }
            else {
                setUserItem(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.id === -1)) {
                var index = newValue.findIndex(x => x.id === -1);
                setUserItem([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.id === -1) && newValue.length === users.length - 1) {
                setUserItem([]);
            }
            else {
                setUserItem(newValue);
            }
        }
        else if (reason === "clear") {
            setUserItem([]);
        }
        //setUserItem(newValue);
    }
    const resetUserMenu = () => {
        setKey([]);
        setDescription("");
        setMenuItem("");
        setUserItem("");
    }
    const handleDescription = (event) => {
        setDescription(event.target.value);
    };
    const isDuplicate = (menuID, userCode, ListKey, ListUser) => {
        let flag = 0;
        let Lkey = ListKey.split(',');
        let LUser = ListUser.split(',');
        props.DataUserMenu.forEach((item, i) => {
            Lkey.forEach((itemr, j) => {
                LUser.forEach((itemu, j) => {
            if (menuID === item.menuID && itemu === item.userCode && item.permission === itemr) {
                NotificationManager.error("Đã tồn tại");
                flag = 1;
            }
        })
        })
        });
        return flag;
    }
    const saveUserMenu = () => {
        if (!menuItem) {
            NotificationManager.error("Vui lòng chọn menu !");
            return false;
        }
        if (!userItem) {
            NotificationManager.error("Vui lòng chọn user !");
            return false;
        }
        if (valueKey.length === 0) {
            NotificationManager.error("Vui lòng chọn quyền");
            return false;
        }
        let ListKey = "";
        if (valueKey) {
            valueKey.forEach((item, i) => {
                if (item.id === -1) {
                    ListKey = "";
                } else {
                    ListKey = ListKey + "," + item.key;
                }
            });
        }
        let ListUser = "";
        if(userItem){
            userItem.forEach((item, i) =>{
                ListUser = ListUser + "," + item.userCode ;
            })
        }
        const DataUserMenu = {
            "MenuID": menuItem.id,
            "LPermission": ListKey.substring(1),
            "Description": valueDescription,
            "LUser": ListUser.substring(1)
        };
        if (isDuplicate(menuItem.id, userItem.userCode,  ListKey.substring(1),ListUser.substring(1) ) === 0) {
            props.SetDataUserMenu(DataUserMenu);
        }
        else {
            console.log("Trùng");
        }
        //window.location.reload();
    }

    const fn_SetKeys = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.id === -1) || (!newValue.some(x => x.id === -1) && newValue.length === keys.length - 1)) {
                setKey(keys);
            }
            else {
                setKey(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.id === -1)) {
                var index = newValue.findIndex(x => x.id === -1);
                setKey([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.id === -1) && newValue.length === keys.length - 1) {
                setKey([]);
            }
            else {
                setKey(newValue);
            }
        }
        else if (reason === "clear") {
            setKey([]);
        }
    }
    return (
        <div className='Bodyui'>
            <div className='PlanTemplate_body'>
                <Accordion className='PlanTemplate_002' expanded={expanded === 'panel1'}>
                    <AccordionDetails>
                        <div className="col-md-6 PlanTemplate_0014">
                            {/* <Autocomplete
                                disablePortal
                                id="combo-box"
                                size='small'
                                options={props.DataUser ? props.DataUser : []}
                                // disableClearable={readOnly}
                                getOptionLabel={(option) => option.email}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Email" variant="outlined" />}
                                renderOption={(option) =>
                                    <Typography noWrap style={{ fontSize: "13px" }}>{option.email}</Typography>}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue) => fn_SetUserItem(newValue)}
                                value={userItem ? userItem : null}
                            /> */}
                            <Autocomplete
                                multiple
                                limitTags={4}
                                id="combo-box"
                                options={users ? users : []}
                                disableCloseOnSelect
                                renderOption={(option, { selected }) => {
                                    return (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            <Typography noWrap style={{ fontSize: "13px" }}>{option.email}</Typography>
                                        </React.Fragment>
                                    )
                                }}
                                getOptionLabel={(option) => option.email}
                                style={{ width: "100%" }}
                                size='small'
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Email" variant="outlined" />}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue, reason) => fn_SetUserItem(newValue, reason)}
                                value={userItem ? userItem: []}
                            />
                        </div>
                        <div className="col-md-6 PlanTemplate_0014">
                            <Autocomplete
                                disablePortal
                                id="combo-box"
                                size='small'
                                options={props.DataMenu ? props.DataMenu : []}
                                //disableClearable={readOnly}
                                getOptionLabel={(option) => option.name}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Menu" variant="outlined" />}
                                renderOption={(option) =>
                                    <Typography noWrap style={{ fontSize: "13px" }}>{option.name}</Typography>}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue) => fn_SetMenuItem(newValue)}
                                value={menuItem ? menuItem : null}
                            />
                        </div>
                        <div className="col-md-6 PlanTemplate_0014">
                            <Autocomplete
                                multiple
                                limitTags={2}
                                id="combo-box"
                                options={keys ? keys : []}
                                disableCloseOnSelect
                                renderOption={(option, { selected }) => {
                                    return (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            <Typography noWrap style={{ fontSize: "13px" }}>{option.key}</Typography>
                                        </React.Fragment>
                                    )
                                }}
                                getOptionLabel={(option) => option.key}
                                style={{ width: "100%" }}
                                size='small'
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Quyền" variant="outlined" />}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue, reason) => fn_SetKeys(newValue, reason)}
                                value={valueKey}
                            />
                        </div>
                        <div className="col-md-6 mt-2 PlanTemplate_0014">
                            <TextField
                                id="outlined-required"
                                variant="outlined"
                                label="Mô tả"
                                placeholder="Mô tả"
                                onChange={(event) => handleDescription(event)}
                                value={valueDescription ? valueDescription : ""}
                                size="small"
                                style={{ width: "100%", fontSize: "10px" }}
                            />
                        </div>
                    </AccordionDetails>
                    <AccordionActions className="PlanTemplate_btnAction">
                        <Button className="PlanTemplate_0021" onClick={saveUserMenu} size="small" startIcon={<MdAddCircleOutline />} variant="contained" color="primary">Thêm</Button>
                        <Button className="PlanTemplate_0021" size="small" onClick={resetUserMenu} startIcon={<MdCached />} variant="contained" color="primary">Reset</Button>
                    </AccordionActions>
                </Accordion>
            </div>
            <div className='tablelistsms'>
                <MaterialTable
                    columns={state.columns}
                    data={props.DataUserMenu}
                    style={{
                        borderRadius: '20px',
                        boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px'
                    }}
                    options={{
                        toolbar: true,
                        paging: true,
                        exportButton: {
                            csv: true,
                            pdf: false
                        },
                        exportAllData: true,
                        filtering: true,
                        // selection: true,
                        headerStyle: {
                            backgroundColor: 'var(--itsm-bg-btn)',
                            color: '#FFF',
                            marginTop: '1%'
                        },
                        actionsColumnIndex: -1
                    }}
                    localization={{
                        pagination: {
                            labelDisplayedRows: 'Từ {from} - đến {to} of {count}'
                        },
                        toolbar: {
                            exportCSVName: "Export danh sách chi tiết",
                            nRowsSelected: 'Đã chọn {0} dòng',
                        },
                        header: {
                            actions: ''
                        },
                        body: {
                            emptyDataSourceMessage: 'Không có dữ liệu',
                            deleteTooltip: "Xóa",
                            filterRow: {
                                filterTooltip: 'Filter'
                            },
                            editRow: {
                                deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                cancelTooltip: "Hủy bỏ",
                                saveTooltip: "Đồng ý",
                            },
                        },
                    }}
                    title=""
                />
            </div>
        </div>
    );
}
export default ShowComponent;